import { Agency } from "../../parsegenerated";

export class AgencyModel {
  agency_id?: string;
  agency_email?: string;
  agency_lang?: string;
  agency_name?: string;
  agency_url?: string;
}

export function toAgencyModel(data: Agency): AgencyModel {
  return {
    agency_id: data.agency_id,
    agency_email: data.agency_email,
    agency_lang: data.agency_lang,
    agency_name: data.agency_name,
    agency_url: data.agency_url,
  };
}
